import BaseClient from "./baseClient.js";
import { projectBuilder, roundBuilder, voteBuilder, roundApplicationBuilder, roundMatchBuilder, } from "./builders.js";
export class Client extends BaseClient {
    constructor(fetchImpl, baseURI, chainId) {
        super(fetchImpl, baseURI, chainId);
        this.routes = {
            projects: "/data/:chainId/projects.json",
            projectVotes: "/data/:chainId/rounds/:roundId/projects/:projectId/votes.json",
            rounds: "/data/:chainId/rounds.json",
            roundVotes: "/data/:chainId/rounds/:roundId/votes.json",
            roundApplications: "/data/:chainId/rounds/:roundId/applications.json",
            roundProjects: "/data/:chainId/rounds/:roundId/projects.json",
            roundMatchingFunds: "/chains/:chainId/rounds/:roundId/matches",
        };
    }
    getProjects() {
        return this.fetchResources("projects", {}, projectBuilder);
    }
    getProjectBy(key, value) {
        return this.fetchResourceFromList("projects", {}, projectBuilder, key, value);
    }
    getProjectsBy(key, value) {
        return this.fetchResourcesFromList("projects", {}, projectBuilder, key, value);
    }
    getProjectById(id) {
        return this.fetchResourceFromList("projects", {}, projectBuilder, "id", id, true);
    }
    getRounds() {
        return this.fetchResources("rounds", {}, roundBuilder);
    }
    getRoundBy(key, value, caseSensitive = false) {
        return this.fetchResourceFromList("rounds", {}, roundBuilder, key, value, caseSensitive);
    }
    getRoundMatchingFunds(roundId) {
        return this.fetchResources("roundMatchingFunds", { roundId }, roundMatchBuilder);
    }
    getRoundProjects(roundId) {
        return this.fetchResources("roundProjects", { roundId }, roundApplicationBuilder);
    }
    getRoundApplications(roundId) {
        return this.fetchResources("roundApplications", { roundId }, roundApplicationBuilder);
    }
    getRoundApplicationBy(roundId, key, value) {
        return this.fetchResourceFromList("roundApplications", { roundId }, roundApplicationBuilder, key, value);
    }
    getVotes(roundId, projectId) {
        if (projectId) {
            return this.fetchResources("projectVotes", { roundId, projectId }, voteBuilder);
        }
        else {
            return this.fetchResources("roundVotes", { roundId }, voteBuilder);
        }
    }
}
